import React, { useEffect } from "react";
import {
  Badge,
  Box,
  Button,
  Flex,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../common/FetchTokenSlice";
import {
  fetchCandidateJobHistoryAsync,
  selectCandidateJobHistory,
} from "./CandidateJobSearchHistorySlice";

function CandidateSearchHistory() {
  const dispatch = useDispatch();
  const jobs = useSelector(selectCandidateJobHistory);
  const token = useSelector(selectToken);
  //   const token = `Bearer 537|OfZPeIAiuRHNvA3cBlbwlkPPz29ZvXyoa20OR3YJ0970c764`;

  useEffect(() => { 
    if (token) { 
      dispatch(fetchCandidateJobHistoryAsync({ token: token }));
    } 
  }, [token, dispatch]);

  //   const handleDelete = (uuid) =>{
  //     if(token){
  //         dispatch(deleteJobSearchHistoryAsync({token: token, uuid: uuid,}))
  //     }
  //   }

  //   const navigate = useNavigate();
  //   const handleDescription = (job) => {
  //     navigate("/jobSingle2", { state: job, replace: true });
  //   };
  return (
    <div>
      <div className="sm:max-w-6xl mx-auto mb-12 sm:p-0">
        {/* Job Cards */}
        <div className="latestjob px-3 sm:px-1">
          {/* Card 1 */}
          {Array.isArray(jobs) && jobs.length > 0 ? (
            <div className="cursor-pointer">
              {jobs.map((job) => (
                <div
                  className="cardkartik flex border-1 sm:max-w-5xl shadow-md sm:mx-auto rounded-lg mb-6 wavecard"
                  // onClick={() => handleDescription(job)}
                >
                  <Box
                    borderWidth="1px"
                    borderradius="md"
                    p={5}
                    bg="white"
                    shadow="sm"
                    _hover={{ shadow: "md", transform: "scale(1.02)" }}
                    transition="all 0.3s"
                  >
                    <Flex justify="space-between" align="center">
                      <Text fontSize="lg" fontWeight="bold" color="blue.600">
                        {job.job_title}
                      </Text>
                      <Badge colorScheme="green">{job.experience} Years</Badge>
                    </Flex>
                    <Text mt={2} fontSize="md" color="gray.600">
                      {job.job_company}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      {job.job_location}
                    </Text>
                    <Stack mt={4} direction="row" spacing={2}>
                      {job.job_skill}
                    </Stack>
                    <Button
                      mt={4}
                      colorScheme="blue"
                      size="sm"
                      variant="outline"
                      _hover={{ bg: "blue.100" }}
                    >
                      View Details
                    </Button>
                    <Button
                    // onClick={handleDelete(job.uuid)}
                    >
                      delete
                    </Button>
                  </Box>
                </div>
              ))}
            </div>
          ) : (
            <div className="flex flex-row justify-evenly px-3 gap-5">
              no previous job search
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CandidateSearchHistory;
